import React from 'react';
import ErrorBack from 'components/error/ErrorBack/ErrorBack';
import Head from 'next/head';
import { Container, Row, Col } from 'reactstrap';
import { ErrorHeading } from 'components/error/ErrorHeading';
import { ErrorSubHeading } from 'components/error/ErrorSubHeading';
import { ErrorWrapper } from 'components/error/ErrorBack';
import { Layout } from 'components/common/Layout';
import { TitleHeader } from 'components/header/TitleHeader';
import { TransparentContainer } from 'components/common/TransparentContainer';

const Error: React.FC = () => {
    return (
        <Layout pathName="404">
            <Head>
                <title>Werken bij Developers.nl</title>
            </Head>
            <TitleHeader center title="Pagina niet gevonden" />
            <ErrorWrapper>
                <TransparentContainer>
                    <Container>
                        <Row>
                            <Col sm={12} lg={{ size: 8, offset: 2 }}>
                                <ErrorHeading>Helaas is er een error (404) opgetreden.</ErrorHeading>
                                <ErrorSubHeading>Excuses voor het ongemak.</ErrorSubHeading>
                                <ErrorBack />
                            </Col>
                        </Row>
                    </Container>
                </TransparentContainer>
            </ErrorWrapper>
        </Layout>
    );
};

export default Error;
